<!--  -->
<template>
  <div>
    <div class="cont_r_b11">
      <p>
        <img :src="images.spfr" alt>
      </p>
      <p>
        <br>
      </p>
      <p>
        <br>
      </p>
      <p>
        <b>
          <u>
            <span style="font-size:16.0pt;font-family:宋体;">水平复绕机组</span>
          </u>
        </b>
        <b>
          <u>
            <span style="font-size:16.0pt;font-family:Arial;"></span>
          </u>
        </b>
      </p>
      <p>
        <span style="font-size:12.0pt;font-family:Arial;">&nbsp;</span>
      </p>
      <p>
        <span
          style="font-family:宋体;font-size:12pt;text-indent:42pt;line-height:1.5;"
        >该机组主要是把盘拉后的散盘成品铜管矫直、清洗、烘干、探伤（打印）、预弯、无屑分卷等工序再分层依次缠绕成密排呈电缆状的盘卷，以作为成品交货或再进行成品退火。我公司产品远销乌克兰等国家。</span>
      </p>
      <p>
        <span>&nbsp;</span>
      </p>
      <div align="center">
        <table
          style="width:418.5pt;"
          class="ke-zeroborder"
          border="0"
          cellpadding="0"
          cellspacing="0"
          width="558"
        >
          <tbody>
            <tr>
              <td>
                <div align="center">
                  <table
                    style="width:90.0%;"
                    class="ke-zeroborder"
                    border="0"
                    cellpadding="0"
                    cellspacing="0"
                    width="90%"
                  >
                    <tbody>
                      <tr>
                        <td style="background:#F4F4F4;">
                          <p style="text-align:center;" align="center">
                            <span
                              style="font-size:11.5pt;line-height:150%;font-family:宋体;color:#000099;"
                            >技术参数</span>
                            <span
                              style="font-size:11.5pt;line-height:150%;font-family:Arial;color:#000099;"
                            ></span>
                          </p>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <div align="center">
                            <table
                              style="background:black;"
                              class="ke-zeroborder"
                              border="0"
                              cellpadding="0"
                              cellspacing="1"
                            >
                              <tbody>
                                <tr>
                                  <td style="background:white;" width="43">
                                    <p style="text-align:center;" align="center">
                                      <span
                                        style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:#333333;"
                                      >No.</span>
                                    </p>
                                  </td>
                                  <td style="background:white;" width="156">
                                    <p style="text-align:left;" align="left">
                                      <span
                                        style="font-size:9.0pt;line-height:150%;font-family:宋体;color:#333333;"
                                      >型号</span>
                                      <span
                                        style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:#333333;"
                                      >
                                        <br>
                                      </span>
                                      <span
                                        style="font-size:9.0pt;line-height:150%;font-family:宋体;color:#333333;"
                                      >技术参数</span>
                                      <span
                                        style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:#333333;"
                                      ></span>
                                    </p>
                                  </td>
                                  <td style="background:white;" width="72">
                                    <p style="text-align:center;" align="center">
                                      <span
                                        style="font-size:9.0pt;line-height:150%;font-family:宋体;color:#333333;"
                                      >单位</span>
                                      <span
                                        style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:#333333;"
                                      ></span>
                                    </p>
                                  </td>
                                  <td colspan="2" style="background:white;" width="156">
                                    <p style="text-align:center;" align="center">
                                      <span
                                        style="font-size:9.0pt;line-height:150%;font-family:宋体;color:#333333;"
                                      >范</span>
                                      <span
                                        style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:#333333;"
                                      ></span>
                                      <span
                                        style="font-size:9.0pt;line-height:150%;font-family:宋体;color:#333333;"
                                      >围</span>
                                      <span
                                        style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:#333333;"
                                      ></span>
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style="background:white;" width="43">
                                    <p style="text-align:center;" align="center">
                                      <span
                                        style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:#333333;"
                                      >1</span>
                                    </p>
                                  </td>
                                  <td style="background:white;" width="156">
                                    <p style="text-align:center;" align="center">
                                      <span
                                        style="font-size:9.0pt;line-height:150%;font-family:宋体;color:#333333;"
                                      >缠绕铜管外径</span>
                                      <span
                                        style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:#333333;"
                                      ></span>
                                    </p>
                                  </td>
                                  <td style="background:white;" width="72">
                                    <p style="text-align:center;" align="center">
                                      <span
                                        style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:#333333;"
                                      >mm</span>
                                    </p>
                                  </td>
                                  <td style="background:white;" width="156">
                                    <p style="text-align:center;" align="center">
                                      <span
                                        style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:#333333;"
                                      >Φ4-19</span>
                                    </p>
                                  </td>
                                  <td style="background:white;" width="78">
                                    <p style="text-align:center;" align="center">
                                      <span
                                        style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:#333333;"
                                      >Φ1.5-8</span>
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style="background:white;" width="43">
                                    <p style="text-align:center;" align="center">
                                      <span
                                        style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:#333333;"
                                      >2</span>
                                    </p>
                                  </td>
                                  <td style="background:white;" width="156">
                                    <p style="text-align:center;" align="center">
                                      <span
                                        style="font-size:9.0pt;line-height:150%;font-family:宋体;color:#333333;"
                                      >最大壁厚</span>
                                      <span
                                        style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:#333333;"
                                      ></span>
                                    </p>
                                  </td>
                                  <td style="background:white;" width="72">
                                    <p style="text-align:center;" align="center">
                                      <span
                                        style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:#333333;"
                                      >mm</span>
                                    </p>
                                  </td>
                                  <td style="background:white;" width="156">
                                    <p style="text-align:center;" align="center">
                                      <span
                                        style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:#333333;"
                                      >1.2</span>
                                    </p>
                                  </td>
                                  <td style="background:white;" width="78">
                                    <p style="text-align:center;" align="center">
                                      <span
                                        style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:#333333;"
                                      >1.0</span>
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style="background:white;" width="43">
                                    <p style="text-align:center;" align="center">
                                      <span
                                        style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:#333333;"
                                      >3</span>
                                    </p>
                                  </td>
                                  <td style="background:white;" width="156">
                                    <p style="text-align:center;" align="center">
                                      <span
                                        style="font-size:9.0pt;line-height:150%;font-family:宋体;color:#333333;"
                                      >最大卷重</span>
                                      <span
                                        style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:#333333;"
                                      ></span>
                                    </p>
                                  </td>
                                  <td style="background:white;" width="72">
                                    <p style="text-align:center;" align="center">
                                      <span
                                        style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:#333333;"
                                      >Kg</span>
                                    </p>
                                  </td>
                                  <td style="background:white;" width="156">
                                    <p style="text-align:center;" align="center">
                                      <span
                                        style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:#333333;"
                                      >300</span>
                                    </p>
                                  </td>
                                  <td style="background:white;" width="78">
                                    <p style="text-align:center;" align="center">
                                      <span
                                        style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:#333333;"
                                      >150</span>
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style="background:white;" width="43">
                                    <p style="text-align:center;" align="center">
                                      <span
                                        style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:#333333;"
                                      >4</span>
                                    </p>
                                  </td>
                                  <td style="background:white;" width="156">
                                    <p style="text-align:center;" align="center">
                                      <span
                                        style="font-size:9.0pt;line-height:150%;font-family:宋体;color:#333333;"
                                      >机组速度</span>
                                      <span
                                        style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:#333333;"
                                      ></span>
                                    </p>
                                  </td>
                                  <td style="background:white;" width="72">
                                    <p style="text-align:center;" align="center">
                                      <span
                                        style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:#333333;"
                                      >m/min</span>
                                    </p>
                                  </td>
                                  <td style="background:white;" width="156">
                                    <p style="text-align:center;" align="center">
                                      <span
                                        style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:#333333;"
                                      >0-300
                                        <br>0-500
                                      </span>
                                    </p>
                                  </td>
                                  <td style="background:white;" width="78">
                                    <p style="text-align:center;" align="center">
                                      <span
                                        style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:#333333;"
                                      >0-120</span>
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style="background:white;" width="43">
                                    <p style="text-align:center;" align="center">
                                      <span
                                        style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:#333333;"
                                      >5</span>
                                    </p>
                                  </td>
                                  <td style="background:white;" width="156">
                                    <p style="text-align:center;" align="center">
                                      <span
                                        style="font-size:9.0pt;line-height:150%;font-family:宋体;color:#333333;"
                                      >成品卷最大外径</span>
                                      <span
                                        style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:#333333;"
                                      ></span>
                                    </p>
                                  </td>
                                  <td style="background:white;" width="72">
                                    <p style="text-align:center;" align="center">
                                      <span
                                        style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:#333333;"
                                      >mm</span>
                                    </p>
                                  </td>
                                  <td style="background:white;" width="156">
                                    <p style="text-align:center;" align="center">
                                      <span
                                        style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:#333333;"
                                      >Φ1230</span>
                                    </p>
                                  </td>
                                  <td style="background:white;" width="78">
                                    <p style="text-align:center;" align="center">
                                      <span
                                        style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:#333333;"
                                      >Φ700</span>
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style="background:white;" width="43">
                                    <p style="text-align:center;" align="center">
                                      <span
                                        style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:#333333;"
                                      >6</span>
                                    </p>
                                  </td>
                                  <td style="background:white;" width="156">
                                    <p style="text-align:center;" align="center">
                                      <span
                                        style="font-size:9.0pt;line-height:150%;font-family:宋体;color:#333333;"
                                      >成品卷宽度</span>
                                      <span
                                        style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:#333333;"
                                      ></span>
                                    </p>
                                  </td>
                                  <td style="background:white;" width="72">
                                    <p style="text-align:center;" align="center">
                                      <span
                                        style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:#333333;"
                                      >mm</span>
                                    </p>
                                  </td>
                                  <td style="background:white;" width="156">
                                    <p style="text-align:center;" align="center">
                                      <span
                                        style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:#333333;"
                                      >120-400</span>
                                    </p>
                                  </td>
                                  <td style="background:white;" width="78">
                                    <p style="text-align:center;" align="center">
                                      <span
                                        style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:#333333;"
                                      >50-200</span>
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style="background:white;" width="43">
                                    <p style="text-align:center;" align="center">
                                      <span
                                        style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:#333333;"
                                      >7</span>
                                    </p>
                                  </td>
                                  <td style="background:white;" width="156">
                                    <p style="text-align:center;" align="center">
                                      <span
                                        style="font-size:9.0pt;line-height:150%;font-family:宋体;color:#333333;"
                                      >成品卷内径</span>
                                      <span
                                        style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:#333333;"
                                      ></span>
                                    </p>
                                  </td>
                                  <td style="background:white;" width="72">
                                    <p style="text-align:center;" align="center">
                                      <span
                                        style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:#333333;"
                                      >mm</span>
                                    </p>
                                  </td>
                                  <td style="background:white;" width="156">
                                    <p style="text-align:center;" align="center">
                                      <span
                                        style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:#333333;"
                                      >Φ610</span>
                                    </p>
                                  </td>
                                  <td style="background:white;" width="78">
                                    <p style="text-align:center;" align="center">
                                      <span
                                        style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:#333333;"
                                      >Φ300</span>
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style="background:white;" width="43">
                                    <p style="text-align:center;" align="center">
                                      <span
                                        style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:#333333;"
                                      >8</span>
                                    </p>
                                  </td>
                                  <td style="background:white;" width="156">
                                    <p style="text-align:center;" align="center">
                                      <span
                                        style="font-size:9.0pt;line-height:150%;font-family:宋体;color:#333333;"
                                      >装机总功率</span>
                                      <span
                                        style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:#333333;"
                                      ></span>
                                    </p>
                                  </td>
                                  <td style="background:white;" width="72">
                                    <p style="text-align:center;" align="center">
                                      <span
                                        style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:#333333;"
                                      >kw</span>
                                    </p>
                                  </td>
                                  <td style="background:white;" width="156">
                                    <p style="text-align:center;" align="center">
                                      <span
                                        style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:#333333;"
                                      >75</span>
                                      <span
                                        style="font-size:9.0pt;line-height:150%;font-family:宋体;color:#333333;"
                                      >，</span>
                                      <span
                                        style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:#333333;"
                                      >90</span>
                                    </p>
                                  </td>
                                  <td style="background:white;" width="78">
                                    <p style="text-align:center;" align="center">
                                      <span
                                        style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:#333333;"
                                      >22</span>
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style="background:white;" width="43">
                                    <p style="text-align:center;" align="center">
                                      <span
                                        style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:#333333;"
                                      >9</span>
                                    </p>
                                  </td>
                                  <td style="background:white;" width="156">
                                    <p style="text-align:center;" align="center">
                                      <span
                                        style="font-size:9.0pt;line-height:150%;font-family:宋体;color:#333333;"
                                      >液压系统压力</span>
                                      <span
                                        style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:#333333;"
                                      ></span>
                                    </p>
                                  </td>
                                  <td style="background:white;" width="72">
                                    <p style="text-align:center;" align="center">
                                      <span
                                        style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:#333333;"
                                      >Kg/cm2</span>
                                    </p>
                                  </td>
                                  <td style="background:white;" width="156">
                                    <p style="text-align:center;" align="center">
                                      <span
                                        style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:#333333;"
                                      >63</span>
                                    </p>
                                  </td>
                                  <td style="background:white;" width="78">
                                    <p style="text-align:center;" align="center">
                                      <span
                                        style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:#333333;"
                                      >40</span>
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style="background:white;" width="43">
                                    <p style="text-align:center;" align="center">
                                      <span
                                        style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:#333333;"
                                      >10</span>
                                    </p>
                                  </td>
                                  <td style="background:white;" width="156">
                                    <p style="text-align:center;" align="center">
                                      <span
                                        style="font-size:9.0pt;line-height:150%;font-family:宋体;color:#333333;"
                                      >液压系统流量</span>
                                      <span
                                        style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:#333333;"
                                      ></span>
                                    </p>
                                  </td>
                                  <td style="background:white;" width="72">
                                    <p style="text-align:center;" align="center">
                                      <span
                                        style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:#333333;"
                                      >L/min</span>
                                    </p>
                                  </td>
                                  <td style="background:white;" width="156">
                                    <p style="text-align:center;" align="center">
                                      <span
                                        style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:#333333;"
                                      >34</span>
                                    </p>
                                  </td>
                                  <td style="background:white;" width="78">
                                    <p style="text-align:center;" align="center">
                                      <span
                                        style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:#333333;"
                                      >24</span>
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style="background:white;" width="43">
                                    <p style="text-align:center;" align="center">
                                      <span
                                        style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:#333333;"
                                      >11</span>
                                    </p>
                                  </td>
                                  <td style="background:white;" width="156">
                                    <p style="text-align:center;" align="center">
                                      <span
                                        style="font-size:9.0pt;line-height:150%;font-family:宋体;color:#333333;"
                                      >压缩空气压力</span>
                                      <span
                                        style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:#333333;"
                                      ></span>
                                    </p>
                                  </td>
                                  <td style="background:white;" width="72">
                                    <p style="text-align:center;" align="center">
                                      <span
                                        style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:#333333;"
                                      >Kg/cm2</span>
                                    </p>
                                  </td>
                                  <td style="background:white;" width="156">
                                    <p style="text-align:center;" align="center">
                                      <span
                                        style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:#333333;"
                                      >4-7</span>
                                    </p>
                                  </td>
                                  <td style="background:white;" width="78">
                                    <p style="text-align:center;" align="center">
                                      <span
                                        style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:#333333;"
                                      >4</span>
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style="background:white;" width="43">
                                    <p style="text-align:center;" align="center">
                                      <span
                                        style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:#333333;"
                                      >12</span>
                                    </p>
                                  </td>
                                  <td style="background:white;" width="156">
                                    <p style="text-align:center;" align="center">
                                      <span
                                        style="font-size:9.0pt;line-height:150%;font-family:宋体;color:#333333;"
                                      >机组总长</span>
                                      <span
                                        style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:#333333;"
                                      ></span>
                                    </p>
                                  </td>
                                  <td style="background:white;" width="72">
                                    <p style="text-align:center;" align="center">
                                      <span
                                        style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:#333333;"
                                      >m</span>
                                    </p>
                                  </td>
                                  <td style="background:white;" width="156">
                                    <p style="text-align:center;" align="center">
                                      <span
                                        style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:#333333;"
                                      >11.5</span>
                                    </p>
                                  </td>
                                  <td style="background:white;" width="78">
                                    <p style="text-align:center;" align="center">
                                      <span
                                        style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:#333333;"
                                      >7.7</span>
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style="background:white;" width="43">
                                    <p style="text-align:center;" align="center">
                                      <span
                                        style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:#333333;"
                                      >13</span>
                                    </p>
                                  </td>
                                  <td style="background:white;" width="156">
                                    <p style="text-align:center;" align="center">
                                      <span
                                        style="font-size:9.0pt;line-height:150%;font-family:宋体;color:#333333;"
                                      >机组中心线标高</span>
                                      <span
                                        style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:#333333;"
                                      ></span>
                                    </p>
                                  </td>
                                  <td style="background:white;" width="72">
                                    <p style="text-align:center;" align="center">
                                      <span
                                        style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:#333333;"
                                      >m</span>
                                    </p>
                                  </td>
                                  <td style="background:white;" width="156">
                                    <p style="text-align:center;" align="center">
                                      <span
                                        style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:#333333;"
                                      >1.5</span>
                                    </p>
                                  </td>
                                  <td style="background:white;" width="78">
                                    <p style="text-align:center;" align="center">
                                      <span
                                        style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:#333333;"
                                      >1.2</span>
                                    </p>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                          <p style="text-align:center;" align="center">
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:#000099;"
                            ></span>
                          </p>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <p style="text-align:center;" align="center">
                  <span style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:#333333;"></span>
                </p>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <p>
        <span style="font-size:12.0pt;font-family:Arial;">
          <br>
        </span>
      </p>
      <p>
        <br>
      </p>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      images: {
        spfr: require("../../../assets/img/common/spfr.jpg")
      }
    };
  },

  components: {},

  methods: {}
};
</script>
<style lang='stylus' rel='stylesheet/stylus'>
</style>


// WEBPACK FOOTER //
// src/components/zh/device/spfr.vue